import { Component, Input } from '@angular/core';
import { UserDataService } from '@services/user-data.service';
import { MsLoginServiceService } from '../../../modules/login/service/ms-login-service.service';

@Component({
	selector: 'app-profile-image',
	templateUrl: './profile-image.component.html',
	styleUrls: ['./profile-image.component.scss'],
})
export class ProfileImageComponent {
	 /** image Url */
	 @Input() imageUrl: string;
	 /** full Name */
	 @Input() fullName: string;
	 /**user ShortName */
	 userShortName: string;
   
	 /**
	  * @constructor
	  * @param userDataSr
	  * @param MsLoginService
	  */
	 constructor(public userDataSr: UserDataService, private MsLoginService: MsLoginServiceService) {
	   this.userDataSr.titleDisplayUpdated.subscribe((bol: boolean) => {
		 if (!this.imageUrl) {
		   this.setUserShortName();
		 } else {
		   this.userShortName = '';
		 }
	   });
   
	   this.userDataSr.userImageUpdated.subscribe((bol: boolean) => {
		const userImage: any = localStorage.getItem('userPhotoURL');
		if (userImage != 'null') {
		  this.userShortName = '';
		  this.imageUrl = userImage;
		} else {
		  this.setUserShortName();
		}
	  });
	 }
   
	 /**
	  * set User ShortName
	  * @returns userShortName
	  */
	 setUserShortName() {
	   this.fullName = this.userDataSr.getTitleDisplay();
	   this.userDataSr.titleDisplayUpdated.next(true);
	   this.userShortName = this.fullName
		 .split(' ')
		 .map((name) => name.charAt(0))
		 .join('')
		 .toUpperCase();
	 }
   }
   
